import { render, staticRenderFns } from "./WaitingPrice.vue?vue&type=template&id=22463962&scoped=true"
import script from "./WaitingPrice.vue?vue&type=script&lang=js"
export * from "./WaitingPrice.vue?vue&type=script&lang=js"
import style0 from "./WaitingPrice.vue?vue&type=style&index=0&id=22463962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22463962",
  null
  
)

export default component.exports